// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { ApplicationNavigationContextProvider } from "../ApplicationNavigation";
import { ApplicationSessionContext } from "../ApplicationSession";
import { ApplicationThemeContext } from "../ApplicationTheme";
import { ApplicationPageContextProvider } from "./ApplicationPageContextProvider";
import { ApplicationContent } from "../ApplicationContent";
import { ApplicationFrame } from "../ApplicationFrame";
import { ApplicationLoader } from "../ApplicationLoader";
import { TenantSelector } from "../../entities/User";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ApplicationPage = () => {
  const {
    setVariant
  } = React.useContext(ApplicationThemeContext);
  const {
    user
  } = React.useContext(ApplicationSessionContext);
  const headerRef = React.useRef();
  const footerRef = React.useRef();
  const contentRef = React.useRef();
  const frame = React.useMemo(() => /*#__PURE__*/_jsx(ApplicationNavigationContextProvider, {
    children: /*#__PURE__*/_jsx(ApplicationPageContextProvider, {
      children: /*#__PURE__*/_jsx(ApplicationFrame, {
        header: /*#__PURE__*/_jsx(ApplicationContent, {
          scope: "header",
          ref: headerRef
        }),
        footer: /*#__PURE__*/_jsx(ApplicationContent, {
          scope: "footer",
          ref: footerRef
        }),
        content: /*#__PURE__*/_jsx(ApplicationContent, {
          scope: "content",
          ref: contentRef
        })
      })
    })
  }), []);
  const selector = React.useMemo(() => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ApplicationLoader, {
      type: "screen"
    }), /*#__PURE__*/_jsx(TenantSelector, {
      show: true,
      cancellable: false
    })]
  }), []);
  React.useEffect(() => {
    setVariant(prevState => user?.profile?.gamme?.toLowerCase() ?? prevState);
  }, [user?.profile?.gamme]);
  return !_.isEmpty(user?.profile) ? frame : selector;
};